import { useRef, useState } from 'react';
import CropImage from '../crop-image/CropImage';
import Image from '../image/Image';
import ConfirmModal from '../confirm-modal/ConfirmModal';
import ButtonBase from '../button/ButtonBase';
import styles from './editable-image.module.less';
import UploadImageBox from './UploadImageBox';

const EditableImage = ({
    className = '',
    uploadBoxClassName = '',
    uploadHandler,
    onDropRejected,
    cropHandler,
    removeImageHandler,
    children,
    src,
    altText,
    editable,
    tmpImage,
    placeholder,
    placeholderLoading,
    aspectRatio = 1200 / 624,
    skipConfirmDeleteModal = false,
}) => {
    const [isCropping, setIsCropping] = useState(false);
    const [loading, setLoading] = useState(false);
    const confirmModalRef = useRef(null);

    const setDefaultState = () => {
        setLoading(false);
        setIsCropping(false);
        confirmModalRef?.current?.close();
    };

    const onSaveCropped = (crop) => {
        setLoading(true);

        cropHandler(crop, tmpImage)
            .then(() => {
                setLoading(false);
                setIsCropping(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const onRemove = () => {
        setLoading(true);

        removeImageHandler()
            .then(() => {
                setDefaultState();
            })
            .catch(() => {
                setDefaultState();
            });
    };

    const cancelCropButtonHandler = () => {
        setDefaultState();
    };

    const image = children ? children : <Image src={src} alt={altText} className={styles.image} />;

    if (!editable) {
        return src ? image : null;
    }

    const cropping = (
        <CropImage
            isOpen={isCropping && tmpImage && !!cropHandler}
            cropImageHandler={onSaveCropped}
            cancelButtonHandler={cancelCropButtonHandler}
            imageUrl={tmpImage}
            isSavingCroppedImage={loading}
            startWidth={100}
            aspect={aspectRatio}
        />
    );

    if (src) {
        return (
            <>
                <ConfirmModal
                    modalRef={confirmModalRef}
                    title={'Ta bort bildet'}
                    successText={'Fjern bildet'}
                    cancelText={'Avbryt'}
                    onClickSuccess={() => {
                        onRemove();
                        confirmModalRef?.current?.close();
                    }}
                />
                <div className={[styles.editableImage, className].join(' ')}>
                    {image}
                    <div className={styles.editImageButton}>
                        <ButtonBase
                            className={styles.editableImageRemover}
                            onClick={() => {
                                if (skipConfirmDeleteModal) {
                                    onRemove();
                                } else {
                                    confirmModalRef?.current?.open();
                                }
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Fjerner …' : 'Fjern bildet'}
                        </ButtonBase>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <UploadImageBox
                uploadHandler={uploadHandler}
                onDropRejected={onDropRejected}
                placeholder={placeholder}
                placeholderLoading={placeholderLoading}
                isCropping={isCropping}
                setIsCropping={setIsCropping}
                className={uploadBoxClassName}
            />

            {cropping}
        </>
    );
};

export default EditableImage;
